import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg, fmtDateTime } from "@/lib/api";
import { PageHeader, EmptyState, Badge } from "@/components/Shared";
import { Button } from "@/components/ui/button";

export default function Alerts() {
  const [rows, setRows] = useState([]);

  const load = () => api.get("/notifications").then(({ data }) => setRows(data)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);

  const readAll = async () => {
    await api.post("/notifications/read-all");
    toast.success("All alerts marked read");
    load();
  };

  return (
    <div data-testid="alerts-page">
      <PageHeader
        eyebrow="Notifications"
        title="Alerts"
        description="Postings, daily orders, adjournments and reminders. SMS / WhatsApp / email delivery is MOCKED for now — every alert is recorded here."
        actions={
          rows.some((r) => !r.read) && (
            <Button data-testid="mark-all-read-button" onClick={readAll}
              className="rounded-none bg-blue-900 hover:bg-blue-800 text-white uppercase tracking-widest text-xs h-11 px-6">
              Mark all read
            </Button>
          )
        }
      />
      {rows.length === 0 ? (
        <EmptyState testId="alerts-empty" title="No alerts yet" hint="You will be intimated of every posting, order and adjournment here." />
      ) : (
        <ul className="space-y-3" data-testid="alerts-list">
          {rows.map((n) => (
            <li key={n.id} className={`border border-border p-5 ${n.read ? "bg-card" : "bg-blue-50/60 dark:bg-blue-950/30"}`} data-testid={`alert-row-${n.id}`}>
              <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                <p className="text-sm font-medium">{n.title}</p>
                <div className="flex items-center gap-3">
                  <Badge className="bg-slate-100 text-slate-800 dark:bg-slate-800 dark:text-slate-200">{n.kind.replace(/_/g, " ")}</Badge>
                  <span className="text-xs text-muted-foreground whitespace-nowrap">{fmtDateTime(n.created_at)}</span>
                </div>
              </div>
              {n.body && <p className="text-sm text-muted-foreground mt-2">{n.body}</p>}
              <p className="text-[11px] text-muted-foreground mt-3 font-mono">{n.delivery}</p>
              {n.case_id && (
                <Link to={`/cases/${n.case_id}`} className="text-xs uppercase tracking-wider text-blue-900 dark:text-blue-400 mt-3 inline-block hover:opacity-70 transition-opacity duration-200">
                  Open case file
                </Link>
              )}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
